import React from 'react';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import '../assets/styles/sessionDisplay.css'
// import { useQueryTabs } from './queryContext';
import AttendanceBarPlot from './AttendanceBarPlot';
import { useAuth } from './Auth/AuthContext';
import { API_BASE_URL } from '../config/api';

const SessionDisplay = ({ month: sessionMonth, year: sessionYear, monthSessions: sessionsList, embedded = false }) => {
    const location = useLocation();
    // const { month, year } = useParams();
    // const { month, year } = location.state || {};
    const month = sessionMonth || location.state?.month;
    const year = sessionYear || location.state?.year;
    const monthSessions = sessionsList || {}; 
    const navigate = useNavigate();
    const [sessionData, setSessionData] = useState([])
    const monthArr = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    const [validResult, setValidResult] = useState(true);
    // const { addTab } = useQueryTabs();
    const [visData, setVisData] = useState([]);
    const { token } = useAuth();
    
    useEffect(() => {
        const fetchSessions = async () => {
            // console.log("month: ", month);
            if(monthArr.indexOf(month) < 0) {
                throw new Error("Invalid month provided")
            }
    
            try {
                const response = await fetch(`${API_BASE_URL}/attendance/sessions/year/${year}/month/${monthArr.indexOf(month) + 1}`, {
                  'headers': {
                    'Authorization': `Bearer ${token}`
                  }
                });
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();
                setSessionData(data)
                console.log(data)
                setValidResult(true);
                generateAnalytics();
            } catch (error) {
              setValidResult(false);
            }
          };
          const generateAnalytics = async () => {
            // const data = {
            //     month,
            //     year,
            //     // dashboardUid: 'adoe401m2y3ggf', // Your actual dashboard UID
            //     // panelId: 1 // Your actual panel ID
            //   };
            const adjustedMonth = monthArr.indexOf(month) + 1;
            console.log(adjustedMonth);
    
              const data = {
                adjustedMonth,
                year
              };          
          
              try {
                const response = await fetch(`${API_BASE_URL}/attendance/update-dashboard-monthyear`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                  },
                  body: JSON.stringify(data)
                });
          
                if (!response.ok) {
                  throw new Error(`Error updating dashboard: ${response.statusText}`);
                }
          
                const responseData = await response.json();
                console.log('Dashboard updated successfully:', responseData);
              } catch (error) {
                console.error('Error updating dashboard:', error);
              }
        };

        fetchSessions();
          
    }, []);

    // useEffect(() => {
    //     const fetchSessionCounts = async () => {
    //       const sessionCount = await Promise.all(sessionData.map(async (session) => {
    //         try {
    //             const response = await fetch(`http://localhost:3002/attendance/sessions/${session.SessionID}`);
    //             if (!response.ok) {
    //                 throw new Error('Network response was not ok');
    //             }
    //             const data = await response.json();
    //             return {
    //               date: new Date(session.Date).toLocaleDateString('en-US', {month: 'short', day: 'numeric'}),
    //               count: data.length
    //             };
    //         } catch (error) {
    //           console.error(`Error fetching session with sessionID ${session.SessionID}`, error);
    //           return {
    //             date: new Date(session.Date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
    //             count: 0
    //           };
    //         }
    //       }));

    //       setVisData(sessionCount);
    //       console.log('visData:', visData);
    //       visData.forEach((entry, i) => {
    //         console.log(`Index ${i}:`, entry, typeof entry.date, typeof entry.count);
    //       });


    //     };
    //     if(sessionData?.length > 0) {
    //       fetchSessionCounts();
    //     }
          
    // }, [sessionData]);
    
    const handleSessionClick = (month, day, year) => {
        //const selectedMonth = event.target.textContent
        const monthStr = monthArr[month - 1]
        navigate(`/attendees/${year}/${monthStr}/${day}`);
    }

    return(
      <div>
        {!embedded && (
          <div className='row'>
            <h1>Sessions in {month} {year}:</h1>
          </div>
        )}
        <div className='row'>
          <div className={!validResult ? 'visible' : 'hidden'}>
            <div>No results found for {month} {year}. Please try another search</div>
            <button className='return-home' onClick={() => {navigate('/')}}>Back to Home</button>
          </div>
        </div>
        <div className={`${validResult ? 'visible' : 'hidden'} plot-wrapper`} data-testid="session-display-card">
          <div className="uumc-session-label">Sessions</div>
          {sessionData.map((session, index) => (
            <div
              key={session.SessionID}
              className="uumc-session-card"
              data-testid="session-dropdown"
              onClick={() => {
                const [year, month, day] = session.Date.split('-');
                handleSessionClick(Number(month), Number(day), Number(year));
              }}
            >
              <div className="uumc-session-left">
                <div className="uumc-session-dot"></div>
                <span className="uumc-session-date" data-testid="session-date">{session.Date}</span>
              </div>
              <div className="uumc-session-right">
                {monthSessions[month]?.[index]?.attendees ?? 0} attendees → 
              </div>
            </div>
          ))}
          <div className="uumc-session-divider"></div>
          <AttendanceBarPlot month={month} year={year} />
        </div>
      </div>
  )
}

export default SessionDisplay;